import React from 'react'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

const lenderBullets = (slug, vertical, apy, minimumBalance) => {
  const bullets = {
    high_yield_savings: {
      wealthfront: (
        <>
          <Font className={styles.xSmallFont}>• ${minimumBalance} min balance to earn APY</Font>
        </>
      ),
      amex: (
        <>
          <Font className={styles.xSmallFont}>• ${minimumBalance} min balance to earn APY</Font>
        </>
      ),
      nationwide: (
        <>
          <Font className={styles.xSmallFont}>• 0.40% base APY</Font>
          <Font className={styles.xSmallFont}>• {apy}% with $1,000 monthly deposit</Font>
        </>
      ),
      discover: (
        <>
          <Font className={styles.xSmallFont}>• ${minimumBalance} min balance to earn APY</Font>
        </>
      ),
    },
    interest_checking: {
      axosdirect: (
        <>
          <Font className={styles.xSmallFont}>• 0.4166% with $1,000 monthly deposit</Font>
          <Font className={styles.xSmallFont}>• {apy}% with 15 transactions a month</Font>
        </>
      ),
    },
  }
  return bullets[vertical][slug]
}

export { lenderBullets }
